// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"abaaa838","453":"d7debb95","667":"59384cde"}[chunkId] + ".chunk.js";
};